<!-- Initial HTTP fetch — status not yet known -->
@if(loading && !summaryStatus){
<div class="flex flex-col h-full w-full items-center justify-center gap-4 p-6">
    <!-- Loading spinner Lottie animation while fetching initial status -->
    <app-lottie-animation [animationData]="queueAnimationData" [loop]="true" [autoplay]="true" width="80px"
        height="80px">
    </app-lottie-animation>
    <p class="text-sm text-gray-500 font-bricolage">Loading summary…</p>
</div>
<!-- Generation in progress (IN_PROGRESS status from backend / socket) -->
}@else if(summaryStatus === GEOTECHNICAL_SUMMARY_STATUS.IN_PROGRESS){
<app-generation-loader title="Generating Report summary"
    description="Analyzing documents and preparing key highlights for you." [animationData]="generationAnimationData"
    [bottomImageSvg]="GEOTECHNICAL_ANALYSIS_SVG.SUMMARIZE" feature="GEOTECHNICAL_SUMMARY" [featureId]="analysisId"
    (resume)="fetchLatestSummary()" />

<!-- Generation failed -->
}@else if(summaryStatus === GEOTECHNICAL_SUMMARY_STATUS.FAILED){
<app-generation-loader title="Failed to generate Report Summary"
    description="We couldn't process the reports right now. Please retry." actionLabel="Retry"
    [bottomImageSvg]="GEOTECHNICAL_ANALYSIS_SVG.SUMMARIZE" (action)="onSubmitSummaryDescription()" />

<!-- Summary not yet generated / queued (NOT_STARTED) -->
}@else if(summaryStatus === GEOTECHNICAL_SUMMARY_STATUS.NOT_STARTED){
<app-generation-loader title="Report summary is in queue"
    description="Your reports are waiting to be processed and summarized shortly." [animationData]="queueAnimationData"
    animationWidth="80px" animationHeight="80px" [bottomImageSvg]="GEOTECHNICAL_ANALYSIS_SVG.SUMMARIZE" />

}@else if (openHistory){
<div class="flex flex-col h-full p-3 w-full">
    <div class="flex items-center gap-2 border-gray-200">
        <app-button [icon]="SVG.GO_BACK" [iconSource]="'svg'" [size]="'default'" variant="text"
            (clicked)="openHistory = false">
        </app-button>
        <p class="font-semibold text-lg">Summary</p>
    </div>
    @if(loadingHistory){
    <div class="flex justify-center items-center flex-1 p-6">
        <div class="loader"></div>
    </div>
    } @else if (summaryHistoryList.length === 0) {
    <div class="flex flex-col items-center justify-center flex-1 p-6 text-gray-500">
        <span>No summary history yet.</span>
    </div>
    } @else {
    <div class="flex flex-col p-4 overflow-auto">
        @for (item of summaryHistoryList; track item._id ?? $index) {
        <div class="flex flex-row items-start justify-between gap-3 py-2 border-b border-gray-200 last:border-b-0">
            <div class="flex flex-col gap-1 min-w-0 flex-1">
                <span class="text-sm text-gray-500">{{ item.createdAt ? (item.createdAt | date:'d MMMM yyyy') :
                    'Summary' }}</span>
                <div class="flex items-center">
                    <app-user-name-display [user]="item.createdBy" [variant]="'avatar-name'"></app-user-name-display>
                </div>
            </div>
            <app-popover #summaryItemPopover [width]="'10rem'" class="flex-shrink-0">
                <ng-template #trigger>
                    <div
                        class="p-1.5 rounded-base hover:bg-gray-100 transition-colors cursor-pointer text-gray-500 flex items-center justify-center">
                        <i class="pi pi-ellipsis-v text-base"></i>
                    </div>
                </ng-template>
                <ng-template #body>
                    <div class="flex flex-col gap-0.5 py-1" (click)="$event.stopPropagation()">
                        @if (!isViewer) {
                        <button type="button"
                            class="flex items-center gap-2 w-full px-3 py-2.5 text-sm text-gray-700 hover:bg-gray-100 rounded-base transition-colors text-left"
                            (click)="onDownloadSummaryItem(item._id); summaryItemPopover.hide()">
                            <i class="pi pi-download text-gray-600"></i>
                            <span>Download</span>
                        </button>
                        }
                        <button type="button"
                            class="flex items-center gap-2 w-full px-3 py-2.5 text-sm text-red-600 hover:bg-red-50 rounded-base transition-colors text-left"
                            (click)="onDeleteSummaryItem(item); summaryItemPopover.hide()">
                            <i class="pi pi-trash"></i>
                            <span>Delete</span>
                        </button>
                    </div>
                </ng-template>
            </app-popover>
        </div>
        }
    </div>
    }
</div>
}
@else{
<div class="flex flex-col h-full w-full min-h-0">
    <div class="flex flex-shrink-0 justify-between items-center p-6 w-full">
        <p class="flex items-center font-semibold text-lg gap-2">
            <span>Summary</span>
            <app-icon [type]="GEOTECHNICAL_ANALYSIS_SVG.AI_GENERATED" [source]="'svg'" [size]="'default'" />
        </p>
        <div class="flex gap-3">
            @if (!isViewer) {
            <app-button [icon]="GEOTECHNICAL_ANALYSIS_SVG.AI_GENERATED" [iconSource]="'svg'" [size]="'default'"
                (clicked)="onRegenerate()" variant="outlined" severity="contrast" pTooltip="Re-Generate"
                tooltipPosition="top">
            </app-button>

            <app-button [icon]="SVG.DOWNLOAD" [iconSource]="'svg'" [size]="'default'" variant="outlined"
                pTooltip="Download" tooltipPosition="top" (clicked)="onDownloadSummaryItem(latestSummaryDetails._id)"
                [disabled]="downloadLoading()">
            </app-button>
            }

            <app-button [icon]="SVG.VERSION" [iconSource]="'svg'" [size]="'default'" variant="outlined"
                pTooltip="History" (clicked)="onHistoryClick()" tooltipPosition="top">
            </app-button>
        </div>
    </div>
    <div class="flex-1 min-h-0 max-h-[calc(100vh-14rem)] overflow-y-auto overflow-x-hidden scrollbar-thin">
        <div class="prose prose-compact text-justify text-sm px-6 pb-6 highlight-transition rounded-base prose-ul:pl-1 prose-ol:pl-2 2xl:prose-ul:pl-4 2xl:prose-ol:pl-3 sm:prose-ul:pl-3"
            [innerHTML]="latestSummaryDetails.summary | formatText" dynamicComponentRenderer
            style="line-height: 1.5rem;">
        </div>
    </div>
</div>
}

<app-dialog [visible]="summaryDescriptionDialogVisible" (closed)="summaryDescriptionDialogVisible = false"
    title="Re-Generate Summary" class="max-w-[40rem]">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-3">
            <p class="text-xs text-gray-400">
                Optionally provide instructions to customise the summary — focus areas, key findings to highlight,
                preferred structure, etc. Leave blank to regenerate with default settings.
            </p>

            <!-- Workspace-level instructions badge — shown when textarea is pre-filled from workspace config -->
            @if (instructionsFromWorkspace) {
            <div
                class="flex items-center gap-1.5 self-start bg-blue-50 border border-blue-200 text-blue-600 text-xs font-medium px-2.5 py-1 rounded-full">
                <i class="pi pi-building text-[10px]"></i>
                <span>Workspace default instructions</span>
            </div>
            }

            <textarea placeholder="e.g. Focus on soil bearing capacity, highlight risks and recommendations…" rows="5"
                class="w-full p-3 border border-gray-300 rounded-base text-sm outline-none placeholder:italic placeholder:text-gray-400 focus:border-orange-500 resize-none"
                [(ngModel)]="summaryDescriptionInput" (input)="instructionsFromWorkspace = false"></textarea>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end">
            <app-button label="Submit" severity="primary" variant="filled" (clicked)="onSubmitSummaryDescription()" />
        </div>
    </ng-template>
</app-dialog>